import { CreateClassroomForm } from 'components/ClassroomsModule/types';
import DEFAULT_FORM from '../../../util/default-form';

export enum ActionType {
  GO_FORWARD,
  GO_BACK,
  ASSIGN_LICENSE,
  UNASSIGN_LICENSE,
  ADD_GROUP,
  REMOVE_GROUP,
  RESET_FORM,
  UPDATE_FORM
}

export interface Action {
  type: ActionType;
  payload?: any;
}

export interface FormState {
  activeStep: number;
  stepCount: number;
  form: CreateClassroomForm;
}

const formReducer = (state: FormState, action: Action): FormState => {
  const { activeStep, stepCount, form } = state;

  switch (action.type) {
    case ActionType.GO_FORWARD: {
      if (activeStep === stepCount - 1) return state;

      const { form } = action.payload;
      return { ...state, activeStep: activeStep + 1, form: { ...form, ...action.payload.form } };
    }
    case ActionType.GO_BACK: {
      if (activeStep === 0) return state;

      const { form } = action.payload;
      return { ...state, activeStep: activeStep - 1, form: { ...form, ...action.payload.form } };
    }
    case ActionType.ASSIGN_LICENSE: {
      const students = form.ADD_STUDENTS.students;
      const { productFamilyId, productCurriculumId, studentId } = action.payload ?? {};
      const student = students[studentId];
      if (!student) return state;

      const licenses = student.licenses ?? [];
      const updatedLicenses = [
        ...licenses.filter(x => x.productFamilyId !== productFamilyId),
        { productFamilyId, productCurriculumId }
      ];

      const updatedStudents = [...students];
      updatedStudents[studentId] = { ...student, licenses: updatedLicenses };

      const updatedForm = { ...form, ADD_STUDENTS: { students: updatedStudents } };
      return { ...state, form: updatedForm };
    }
    case ActionType.UNASSIGN_LICENSE: {
      const students = form.ADD_STUDENTS.students;
      const { productCurriculumId, studentId } = action.payload ?? {};
      const student = students[studentId];
      if (!student) return state;

      const licenses = student.licenses ?? [];
      const updatedLicenses = licenses.filter(x => x.productCurriculumId !== productCurriculumId);

      const updatedStudents = [...students];
      updatedStudents[studentId] = { ...student, licenses: updatedLicenses };

      const updatedForm = { ...form, ADD_STUDENTS: { students: updatedStudents } };
      return { ...state, form: updatedForm };
    }
    case ActionType.ADD_GROUP: {
      const students = form.ADD_STUDENTS.students;
      const { group, studentId } = action.payload ?? {};
      const student = students[studentId];
      if (!student) return state;

      const updatedStudents = [...students];
      updatedStudents[studentId] = { ...student, group };

      const updatedForm = { ...form, ADD_STUDENTS: { students: updatedStudents } };
      return { ...state, form: updatedForm };
    }
    case ActionType.REMOVE_GROUP: {
      const students = form.ADD_STUDENTS.students;
      const { studentId } = action.payload ?? {};
      const student = students[studentId];
      if (!student) return state;

      const { group, ...studentWithoutGroup } = student;
      const updatedStudents = [...students];
      updatedStudents[studentId] = studentWithoutGroup;

      const updatedForm = { ...form, ADD_STUDENTS: { students: updatedStudents } };
      return { ...state, form: updatedForm };
    }
    case ActionType.RESET_FORM: {
      return { activeStep: 0, stepCount, form: DEFAULT_FORM };
    }
    case ActionType.UPDATE_FORM: {
      return { ...state, form: { ...form, ...action.payload.form } };
    }
    default: {
      throw new Error(`Unhandled type: ${action.type}`);
    }
  }
};

export default formReducer;
